module.exports = __webpack_public_path__ + "img/store.89d46d73.svg";